// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1zjFb","question":"Question_question__hP_7l","description":"Question_description__11Hf_"};